"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.offsetTop = offsetTop;
exports.offsetBottom = offsetBottom;
exports.elementTop = elementTop;
exports.elementBottom = elementBottom;

var _reactDom = require("react-dom");

var _reactDom2 = _interopRequireDefault(_reactDom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function offsetTop() {
    var off = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

    return function (x, y) {
        return x < off && (typeof y !== "number" || y > off) ? off : false;
    };
}

function offsetBottom() {
    var off_ = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

    return function (x, y) {
        var off = window.innerHeight - off_;
        return x > off && (typeof y !== "number" || y < off) ? off_ : false;
    };
}

function elementTop(ele) {
    return function () {
        return offsetTop(_reactDom2.default.findDOMNode(ele).getBoundingClientRect().bottom).apply(undefined, arguments);
    };
}

function elementBottom(ele) {
    return function () {
        return offsetBottom(_reactDom2.default.findDOMNode(ele).getBoundingClientRect().bottom).apply(undefined, arguments);
    };
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@alicd_crui-table@0.0.78@@alicd/crui-table/lib/sticky-fn.js
// module id = 699
// module chunks = 0